import BackendApiClient from './BackendApiClient';

class BrandConfigManager {
  // The API base URL is the host root, so the brand endpoint carries the /api prefix,
  // unlike the /staff/* endpoints used by the other managers.
  // `host` wins over `partner` server-side: on a partner's own orders host the hostname is
  // the stronger statement, and a slug can be one this tab kept from elsewhere.
  get = ({ partner = null, host = null }) =>
    BackendApiClient.requestAsync({
      method: 'GET',
      url: '/api/brand-config',
      params: { partner, host },
    });
}

export default new BrandConfigManager();
